import { tablemill } from "../tablemill_metal";
import { GraphForm } from "../view/graph_form";
import { RankingForm } from "../view/ranking_form";

class RankingsController {
  private rankingForm: any;
  private graphForm: any;

  constructor() {
    tablemill.onController("rankings", () => {
      this.rankingForm = new RankingForm();
      this.rankingForm.initialize();

      this.graphForm = new GraphForm();
      this.graphForm.enableCsvButton(jQuery(".ranking_table_box .csv_button"));
    });
  }
}

export { RankingsController };
